export const getDateFormat = ({ date, options }) => {
  try {
    const { locales = 'en-US', ...rest } = options;
    return new Intl.DateTimeFormat(locales, { ...rest }).format(date);
  } catch (err) { }
};

export const getDataFromObject = (obj, key) => {
  if (!obj || (typeof obj !== 'object' && !Array.isArray(obj))) {
    return null;
  } else if (obj.hasOwnProperty(key)) {
    return obj[key];
  } else if (Array.isArray(obj)) {
    for (const item of obj) {
      const result = getDataFromObject(item, key);
      if (result) {
        return result;
      }
    }
  } else {
    for (const k in obj) {
      const result = getDataFromObject(obj[k], key);
      if (result) {
        return result;
      }
    }
  }

  return null;
};

export const copyTextToClipboard = async (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to copy text: ', error);
    }
  } else {
    // eslint-disable-next-line no-console
    console.error('Clipboard API is not available');
  }
};


export const debounce = (func, ms = 500) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, ms);
  };
};

export const isBuyNowDisabled = (totalShare, noOfShares) => {
  const sharesRemainingToPurchase = (Number(totalShare) * 9.8) / 100 - Number(noOfShares);
  return Number(noOfShares) > sharesRemainingToPurchase;
};
